// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f4f988d4","33":"6f92e0f6","52":"c6ba4e36","118":"3766d710","138":"4e4a1830","237":"c675c1aa","262":"4d5554fe","453":"40960092","467":"3740bb77","518":"63fdf425","647":"6be36575","787":"1b0e48e0","937":"76bc19ca"}[chunkId] + ".chunk.js";
};